module.exports = __webpack_public_path__ + "static/media/img_12-3.71ab5b30.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/v2/img_12-3.png
// module id = 711
// module chunks = 0